<ion-header>
  <ion-toolbar>
    <ion-title>Manage Table Columns</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="column-manager-content">
    <p class="instructions">
      Drag columns to reorder them, and toggle visibility using the checkboxes. Required columns cannot be hidden.
    </p>

    <div class="columns-list" cdkDropList (cdkDropListDropped)="onDrop($event)">
      <div *ngFor="let column of workingColumns" class="column-item" cdkDrag [cdkDragDisabled]="column.required">
        <div class="column-content">
          <ion-icon name="reorder-three-outline" class="drag-handle" [class.disabled]="column.required"></ion-icon>

          <ion-checkbox
            [checked]="column.visible"
            [disabled]="column.required"
            (ionChange)="toggleColumn(column)"
            class="column-checkbox"
          ></ion-checkbox>

          <span class="column-name">{{ column.name }}</span>

          <ion-chip *ngIf="column.required" color="primary" class="required-chip"> Required </ion-chip>
        </div>
      </div>
    </div>

    <div class="actions">
      <ion-button fill="clear" color="medium" (click)="resetToDefault()"> Reset to Default </ion-button>

      <div class="action-buttons">
        <ion-button fill="clear" color="medium" (click)="cancel()"> Cancel </ion-button>

        <ion-button fill="solid" color="primary" (click)="save()"> Save Changes </ion-button>
      </div>
    </div>
  </div>
</ion-content>
